<template>
    <div class="">
      <h2 v-text="t.configurations"></h2>

      <div class="__identify">
        <span v-text="t.email+':'"></span>
        <h2>{{ this.$parent.toUnicode(email.email, true) }}</h2>
      </div>

      <div class="margin-top-large __list">
        <ul>
          <div v-if="processing" class="__loader_container"></div>
          <li v-else v-for="a in alias">
            <span v-text="$parent.toUnicode(a, true)"></span>
            <a class="button__email button__delete" @click="deleteAlias(a)" data-ba-i="delete-alias">
              <img src="/internacional/public/emails-app/ic_delete.svg"/>
              <span v-text="t.general_label_delete"></span>
            </a>
          </li>
        </ul>
      </div>

      <div class="__block__right margin-top-large">
        <a class="button__email" @click="openNewAlias()" data-ba-i="open-create-alias-modal">
          <span v-text="t.label_criar"></span>
        </a>
      </div>

      <div id="modalAddAlias" class="modal inmodal fade __mailsapp_modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <div>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" data-ba-i="close-create-alias-modal"><span aria-hidden="true">&times;</span></button>
                
                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path class="svg--primary" fill-rule="evenodd" clip-rule="evenodd" d="M36.6667 7.33325H7.33341C5.31675 7.33325 3.68508 8.98325 3.68508 10.9999L3.66675 32.9999C3.66675 35.0166 5.31675 36.6666 7.33341 36.6666H36.6667C38.6834 36.6666 40.3334 35.0166 40.3334 32.9999V10.9999C40.3334 8.98325 38.6834 7.33325 36.6667 7.33325ZM36.6667 14.6666L22.0001 23.8333L7.33342 14.6666V10.9999L22.0001 20.1666L36.6667 10.9999V14.6666Z" fill="#0080FC"/>
                </svg>

                <h2 class="modal-title" v-text="t.enter_email"></h2>
              </div>
            </div>
            <div class="modal-body">
              <div class="input__div">
                <label v-text="t.enter_email_address"></label>
                <div class="mail__input">
                  <input type="text" v-model="alias_user">
                  <input type="text" :value="'@'+email.domain" :size="email.domain.length + 1" spellcheck="false" readonly="readonly">
                </div>
              </div>
              <div v-if="!is_valid_new_alias">
                  <h5 class="__error__input" v-text="t.invalid_email_entered"></h5>
              </div>
              <div class="modal-footer">
                <a class="button__email button__save" @click="handleCreateAlias()" data-ba-i="save-create-alias">
                  <span v-text="t.button_salvar"></span>
                </a> 
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
</template>

<script type="text/javascript">

  import qs from "qs";
  import punycode from "punycode";

  export default {

    name: "emails-settings-alias",

    data() {
      return {
        h: this.$parent.app.handlers,
        t: this.$parent.app.translations,
        processing: false,
        email: this.$parent.app.email,
        alias: [],
        new_alias: null, 
        is_valid_new_alias: true,
        alias_user: ''
      };
    },
    watch: {
      alias_user: function (val) {
        if(val){
          this.new_alias = this.$parent.toASCII(this.alias_user + '@' + this.email.domain, true)
          this.is_valid_new_alias = this.$parent.validateEmail(this.new_alias, true)
        }
      },
    },
    mounted(){
      this.list()
    },
    methods: {
      openNewAlias () {
        if(!this.processing){
          this.new_alias = ''
          this.alias_user = ''
          this.is_valid_new_alias = true
          $('#modalAddAlias').modal('show')
        }
      },
      list(){
        let vm = this
        vm.processing = true
        
        axios
            .post(
                vm.h.routes.forwardings_list,
                qs.stringify({domain: vm.email.domain, email: vm.email.email, type: 'alias'})
            )
            .then(function(response) {
                if(response.data.status){
                  vm.alias = response.data.data.alias
                }
            })
            .catch(function(error) {

            })
            .finally(function(){
              vm.processing = false
            });
      },
      deleteAlias(alias){
        let vm = this
        var confirmLoader = $.confirm({
          title:   vm.t.general_label_delete,
          content: vm.t.confirm_delete_alias,
          type:'red',
          buttons: {
            deletAlias: {
                  text: vm.t.general_label_delete,
                  btnClass: 'btn-danger',
                  action: function () {
                    confirmLoader.showLoading(true);
                    axios
                        .post(
                            vm.h.routes.forwardings_delete,
                            qs.stringify({domain: vm.email.domain, source: alias, destination: vm.email.email})
                        )
                        .then(function(response) {
                            if(response.data.status){
                              
                              let index = vm.alias.indexOf(alias);
                              if (index > -1) {
                                 vm.alias.splice(index, 1);
                                 vm.alias.filter(function(val){return val})
                              }
                                $.alert({
                                  title: vm.t.label_success,
                                  content: response.data.data,
                                  type: 'green',
                              });
                              d.emails.splice(e, 1)
                            }else{
                              $.alert({
                                title: vm.t.label_error,
                                content: response.data.data,
                                type: 'red',
                              });
                            }
                            confirmLoader.close();
                        })
                        .catch(function(error) {
                          confirmLoader.close();
                        });
                    return false;

                  }
              },
              cancelAction: {
                text: vm.t.button_cancelar
              }
          }
        });
      },
      handleCreateAlias(){
        this.new_alias = this.$parent.toASCII(this.alias_user + '@' + this.email.domain)
        this.is_valid_new_alias = this.$parent.validateEmail(this.new_alias)
        if(this.is_valid_new_alias){
          this.createAlias(this.new_alias)
          $('#modalAddAlias').modal('hide')
        }
      },
      createAlias(alias){
        let vm = this
        let load = $.dialog({
            title: false,
            content: '',
            type: 'blue',
            onOpen: function () {
              load.showLoading(true)
          },
        });

        axios
          .post(
              vm.h.routes.forwardings_create,
              qs.stringify({domain: vm.email.domain, source: alias, destination: vm.email.email, type:'alias'})
          )
          .then(function(response) {
              if(response.data.status){
                vm.alias.push(alias)
                $.alert({
                  title: vm.t.label_success,
                  content: response.data.data,
                  type: 'green',
                });
                
              }else{
                $.alert({
                  title: vm.t.label_error,
                  content: response.data.data,
                  type: 'red',
                });
              }
          })
          .catch(function(error) {
            })
          .finally(function(response){
            load.close()
          });
      }
    },

  };
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// resources/office/js/components/emails-app/settings/alias.vue